import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";
import Dropzone from "react-dropzone";
import cloudinary from "cloudinary";
import request from "superagent";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, cloneAllProps, delay, } from "src/lib/util";
import { logProps, } from "src/components/common/enhancers";
import env from "src/vars";

// --------------------------------------------------

const noop = () => {};

export { plog, cloneAllProps, delay, };

export const createAsset = ({
	space, 
	file,
	log,
	onUploaded = noop,
	onProcessed = noop,
	onPublished = noop,
}) => {
	const maybePlog = log ? plog : R.identity;

	return (
		request.post(env.CLOUDINARY_UPLOAD_URL)
		.field("upload_preset", env.CLOUDINARY_UPLOAD_PRESET)
		.field("file", file)
		.then(res => {
			if (res.body.secure_url.length) {
				return res.body.secure_url;
			}
			else {
				console.error("cloudinary error");
				throw new Error("cloudinary error");
			}
		})
		.then(url => space.createAsset({
			fields: {
				file: {
					[consts.lang]: {
						contentType: file.type,
						fileName: file.name,
						upload: url,
					},
				},
			},
		}))
		.then(maybePlog("asset uploaded"))
		.then(R.tap(onUploaded))	

		.then(asset => asset.processForAllLocales())
		.then(maybePlog("asset processed"))
		.then(R.tap(onProcessed))

		.then(asset => asset.publish())
		.then(maybePlog("asset published"))
		.then(R.tap(onPublished))
	);	
};

// space.createAssetFromFiles({
// 	fields: {
// 		file: {
// 			[consts.lang]: {
// 				contentType: file.type,
// 				fileName: file.name,
// 				file,
// 			},
// 		},
// 	},
// })

export const createEntry = ({
	space,
	fields,
	contentType,
}) => (
	space.createEntry(contentType, {
		fields: R.map(R.objOf(consts.lang))(fields),
	})
);

export const createGalleryImage = o => (
	createAsset(o)
	.then(asset => createEntry({
		space: o.space,
		contentType: "gallery-image",
		fields: {
			title: o.file.name,
			tags: o.tags || [],
			image: {
				sys: {
					type: "Link",
					linkType: "Asset",
					"id": asset.sys.id,
				},
			},
			uploadHash: o.uploadHash,
		},
	}))
	.then(entry => entry.publish())
);

export const getTagString = tagArray => (tagArray || []).join(", ");
export const getTagArray = tagString => (tagString || "").split(", ");


// WEBPACK FOOTER //
// ./src/components/common/functions.js